export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_35-af743c26bfd10154b2670fe5da10a31c.jpg";